import { createSlice } from "@reduxjs/toolkit";
import { fetchAllCustomers, fetchCustomerById } from "./thunk";

interface LabourState {
    customerList: any[];
    rowCount: number;
    loading: boolean;
    error: string | null;

    selectedCustomer: null,
}

const initialState: LabourState = {
    customerList: [],
    rowCount: 0,  
    loading: false,
    error: null,
    selectedCustomer: null,
}

const customerSlice = createSlice({
    name: "customer",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
        // Fetch ALL Customers
            .addCase(fetchAllCustomers.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchAllCustomers.fulfilled, (state, action) => {
                state.loading = false;
                state.customerList = action.payload.data;
                state.rowCount = action.payload.rowCount;
            })
            .addCase(fetchAllCustomers.rejected, (state, action) => {
                state.loading = false;
                const errorPayload = action.payload as any;
                state.error = typeof errorPayload === "string" 
                    ? errorPayload 
                    : errorPayload?.error || errorPayload?.message || action.error.message || "Failed to fetch Customers";
            })

        // Fetch Single Customer by ID
            .addCase(fetchCustomerById.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchCustomerById.fulfilled, (state, action) => {
                state.loading = false;
                state.selectedCustomer = action.payload;
            })
            .addCase(fetchCustomerById.rejected, (state, action) => {
                state.loading = false;
                const errorPayload = action.payload as any;
                state.error = typeof errorPayload === "string" 
                    ? errorPayload 
                    : errorPayload?.error || errorPayload?.message || action.error.message || "Failed to fetch Customer";
            })
    }})


export default customerSlice.reducer;